// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"96":"0ef30fcadec9399f8676","315":"8a50f0b477d92f4bc35e","354":"e918aefb12e5ddfda05b","418":"572ed22d9d438385414a","713":"6e93170e3d9c826b482c","822":"eb0a15279b6f680e2385","833":"cc4f1ae7542c7ab5e486","874":"e513d590e59c406c2771"}[chunkId] + ".bundle.js";
};